<template lang="pug">
#en
  .vheader
    .container
      a(href="http://f.geekpark.net")
        img.logo(src='../assets/imgs/header-logo-m.png', alt='Frontier')
      ul
        li(:class="{active : $route.name == 'index'}")
          a(href="http://f.geekpark.net") CN
  .banner-en
    .en-pics
      img(:srcset="`/static/img/banner-m-0${step}.jpg 1000w, /static/img/banner-0${step}.jpg 1080w`" :src="`/static/img/banner-0${step}.jpg`")
    .en-block
      .container.padding
        .title-block
          h1
            | GET
            br
            | LINKED &
            br
            |PLUGGED
          .text
            .title Where core players of the Chinese tech industry get linked and plugged
            p.ps
              | With like-minded innovators worldwide
              br
              | With science, tech, and business innovation
              br
              | With all things that may change games
        .video-block
          h2
            | Keep always fresh
            br
            | Get always ready
          p.ps
            | Builds up a decentralized life-learning community to share true insights,
            | discuss real problems, spark intensive thinking.
          //- a(href='/video')
          //-   | Watch the video
          //-   .play-btn
          //-     .triangle-right
        .list-block
          dl
            dd
              .desc
                | Not
                br
                | what’s new
              .title But what matters
              p.ps We set well-chosen topics for discussion, even debate. Only select what’s important, what’s notable, and what’s worth taking time to zoom in.
            dd
              .desc
                | Not
                br
                | what’s known
              .title But what's going on
              p.ps For the new generation entrepreneurs, they need hands-on know-how, instead of printed knowledge, because they are more often faced with problems that never happen.
            dd
              .desc
                | Not
                br
                | training
              .title But what learning
              p.ps Socratic discussions are often the most inspiring and the most effective way to get a thorough view. Here, no tutors, but views collisions.
  .invitation
    .container.padding
      h1 INVITATION-Only EVENTS
      .item
        .header
          h2 FIELD STUDY
          .title-second CEO VS CEOS
          p.ps Decentralized discussions among founders who know founders’ challenges best.
        .talk We Talk About ...
        .content
          .title For a tech company of today, who has to grow fast to live.
          p.ps
            | • Vision VS Reality — how to balance the energy put on each
            br
            | • Mission & Culture — how to maintain a strong company culture as you grow
            br
            | • Leadership & Management — how to lead and manage to keep both efficient and creative
            br
            | • Product & Business — how a tech company define and construct its product and business models
      .item
        .header
          h2 FRONTIER WORKSHOp
          .title-second Industry VS Academia
          p.ps Link top academic institutions and academic leaders across the world with the tech industry
        .talk We Talk About ...
        .content
          .title Trending Areas
          p.ps
            | AI & AI Applications / Data Science / IoT / Self Driving & New Transportation / Artificial Satellite & Space Exploration / Robotics / ......
        .content
          .title Fundamental Research
          p.ps
            | Neuroscience / Life Science / Mechanical Engineering / Electric Engineering / Applied Mathematics / Applied Physics / Material Science / ...
      .item
        .header
          h2 OVERCLOCKING CAMP
          .title-second Map Out Global Innovations
          p.ps Immersive dialogues at a line of tech titans, startups to watch, and research institutions.
        .talk USA / Canada /Israel / Europe ...
  .funders
    .container.padding
      h1 the most remarkable startup FOUNDERS
      .items-list
        .item
          .title
            | Valuations :
            br
            | >50% with $1 Billion
            br
            | >25% with $100 Million+
          p.ps They are technologists, who address big problems that impact thousands millions of people.
        .item
          .title
            | Insightful Tech Leaders
          p.ps They know algorithms, but they know better that algorithms are not the final goal. It is them who make tech be products, and make products matter.
        .item
          .title
            | New-mindset-equipped Investors
          p.ps They know how to be a launchpad for emerging ideas. And they know how to make things closer to happen.
      .expert-wapper
        ul
          li.expert-item(v-for="(item, $index) in whoareat.items")
            img(:src="['/static/img/'+item.pic]")
            .info
              p.title {{item.name}}
              p.from {{item.from}}
              p.position(v-html="item.position")
            // p.brief {{item.brief}}
  .linked
    .container.padding
      h1.relative WHO WE LINKED
      .img-no
        img(src='../assets/imgs/map.jpg', alt='我们曾抵达...')
      .footprint
        ul
          li
            img(src='../assets/imgs/en-linked-01.jpg')
            p Meet Apple’s former CEO John Sculley
          li
            img(src='../assets/imgs/en-linked-02.jpg')
            p In-depth communications @Google
          li
            img(src='../assets/imgs/en-linked-03.jpg')
            p GeekPark’s China-theme forum @ Facebook
          li
            img(src='../assets/imgs/en-linked-04.jpg')
            p Meet Twitter’s former CEO Dick Costolo
          li
            img(src='../assets/imgs/en-linked-05.jpg')
            p @Nvidia
          li
            img(src='../assets/imgs/en-linked-06.jpg')
            p @Pinterest
      .friends
        h2 GEEKPARK’S FRIENDS
        ul
          li(v-for="(item, $index) in friends.items")
            img(:src="['/static/img/'+item.pic]")
            .info
              p.name {{item.name}}
              p.company {{item.company}}
              p.position {{item.position}}
  .about
    .container.padding
      h1 About GeekPark
      .center.max-w.about-meet
        h2
          | To Meet Your Like-Minded
          br
          | at GeekPark
        p.center.ps
          | Founded in 2010, GeekPark is one of China’s largest internet and technology innovation communities,
          br
          | as well as the first one who introduces the concept “Geek” into China. 
          br
          | Over the past seven years, GeekPark has developed to be a notable force of the innovators & for the innovators
      .list-block
        dl
          dd
            .title
              | GeekPark
              br
              | Media
            .desc-t
              b Renowned
              br
              | Independent
              br
              | Tech Media
            p.ps 300,000 Readers
          dd
            .title
              | The
              br
              | Frontier
            .desc-t
              b High-profile
              br
              | Tech Leaders
              br
              | Association
            p.ps 50 New Members Enrolled Every Year from TOP 5% Tech Companies
          dd
            .title
              | GeekPark IF
              br
              | & Rebuild
            .desc-t
              b Influential
              br
              | Annual Events
              br
              | For Innovators
            p.ps The Most High-quality Tech Events in China With 10,000+ Attendees and Speakers from All over the World
      .help
        .img
          img(src='../assets/imgs/en-about.jpg')
        .desc
          | We help you better
          br
          b access to resources,
          br
          b build up image and release impact
          |  in China.

  .vfooter
    .footer-wrap
      .container
        .contact
          p
            img(src='../assets/imgs/tel.svg')
            | 132 6332 1278
          p
            a.mail(href='mailto:thefrontier@geekpark.net')
              img(src='../assets/imgs/mail.svg')
              | thefrontier@geekpark.net
          p.site Powered by <a href="http://www.geekpark.net" target="_blank">GeekPark</a>
        .follow
          p
            img(src='../assets/imgs/qrcode.jpg', alt='前沿社公众号')
            br
            | Follow us
</template>

<script>

export default {
  data() {
    return {
      step: 1
    }
  },
  computed: {
    friends() {
      return this.$store.state.config['enfriends']
    },
    whoareat() {
      return this.$store.state.config['whoareat']
    }
  },
  mounted(){
    setInterval(()=>{this.step = this.step % 5 + 1}, 6000)
  }
}
</script>

<style lang="styl">
@import '../assets/css/var';
$gray = #808080
$grayLight = #999
$psize = 12px
#en
  background #fff
  h1
    font-size 160px
    font-family 'BebasNeue', sans-serif
    line-height 0.85
  h2
    font-size 80px
    font-family 'BebasNeue', sans-serif
    line-height 0.85
  .ps
    font-size 12px
    line-height 1.5
    color $gray
  b
    font-weight 700
  .relative
    position relative
  .center
    text-align center
    margin auto
  .max-w
    max-width 800px
  .container.padding
    padding 40px
  .img-no
    margin -80px
    img
      width 100%

  .banner-en
    .en-pics
      position absolute
      width 100%
      min-width 1080px
      overflow hidden
      background #000
      img
        display block
        width 100%
        animation moveBg 20s linear
        animation-direction alternate
        animation-iteration-count infinite

      .triangle-pic-slide
        position absolute
        top 0
        left 0
        opacity 0
        transition opacity 2s

        &.active
          opacity 1
          transition opacity 2s

    .en-block
      position relative
      padding-top 300px
      background-image linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 1));
      text-align left
      color #fff
    .title-block
      display flex
      justify-content space-between
      align-items flex-end
      h1
        width 45%
        margin-right 20px
      .text
        color $gray
        width 40%
        margin-bottom 10%
        .title
          font-size 28px
          font-weight 700
          margin 0 0 1em 0
    .video-block
      clear both
      text-align center
      margin 40px 0
      h3
        font-family 'BebasNeue', sans-serif
        font-size 50px
      p
        margin 1em 0
      .play-btn
        border 2px solid currentColor
        border-radius 50%
        display inline-block
        margin-left .5em
        width 1.2em
        height 1.1em
        padding .15em 0 0 .1em
        vertical-align middle
      a
        color #5FC4FF
        font-weight bold
        font-size 16px

  .list-block
    margin 80px 0
    dl
      display flex
      justify-content space-between
      dd
        width 25%
        .desc
          font-family 'BebasNeue', sans-serif
          color $gray
          font-size 38px
        .desc-t
          font-size 18px
          color $grayLight
          line-height 1.2
          b
            font-weight 700
        .title
          font-family 'BebasNeue', sans-serif
          font-size 50px
          line-height 1
  .invitation
    background #F2F2F2
    .item
      width 50%
      margin 50px auto
      .header
        text-align center
        .title-second
          font-size 16px
          color $grayLight
          font-weight 600
          line-height 1.5
      .talk
        font-size 16px
        margin 2em 0 1em
        font-weight 600
      .content
        .title
          font-size 16px
          color $grayLight
          font-weight 600
          margin .5em 0

  .funders
    .items-list
      display flex
      justify-content space-between
      margin 5em 0
      .item
        width 30%
        .title
          display flex
          align-items center
          font-weight 700
          color $gray
          min-height 3.6em
          line-height 1.2
          margin-bottom 0.5em
          font-size 14px
        p
          line-height 1.2
    .expert-wapper
      padding-bottom 10px
      ul
        display flex
        flex-flow row wrap
        justify-content space-between
      .expert-item
        display inline-block
        width 30%
        margin-top 15px
        border-bottom 2px solid #000
        line-height 1.5em
        img
          float left
          width 30%
          margin-right 5%
        .info
          display inline-block
          width 65%
        p.title
          font-size 16px
          height 40px
        p.from
          font-size 13px
        p.position
          color #999
        p.brief
          clear both
          padding 10px 0
          line-height 1.2em
          color #999

  .footprint
    ul
      display flex
      flex-flow row wrap
      justify-content space-between
    li
      width 33%
      img
        width 100%
      p
        text-align center
        line-height 2
        margin-bottom 1em
  .linked
    .friends
      h2
        text-align center
        margin 0.5em 0
      li
        width 15%
        display inline-block
        vertical-align top
        margin-right 2%
        margin-bottom 1%
        &:nth-child(6n+0)
          margin-right 0%
        img
          width 100%
        .info
          border-left 2px solid #000
          padding 5px
          margin-top 1%
          p.name
            font-weight 700
            font-size 16px
            line-height 2
          p.company
          p.position
            font-size 12px
            color $gray
            line-height 1.5
          p.company
            font-weight 700
  .about
    background #000
    color #fff
    .about-meet
      margin 50px auto
    .help
      .img
        display inline-block
        vertical-align middle
        width 50%
        img
          width 100%
      .desc
        display inline-block
        vertical-align middle
        margin-left 5%
        width 45%
        font-size 36px
        line-height 1.2
        font-weight 300

  @media $media
    .container.padding
      padding 20px
    .img-no
      margin -40px -20px
    h1
      font-size 70px
    h2
      font-size 40px
    .ps
      font-size 10px

    .banner-en
      .en-block
        padding-top 200px
        background-image linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 1))
      .en-pics
        min-width auto
      .title-block
        flex-flow column wrap
        h1
          width 100%
          margin-right 0px
        .text
          width 100%
          margin 5% 0

    .list-block
      margin 40px 0
      dl
        flex-flow column wrap
        dd
          width 100%
          margin 20px 0

    .invitation
      .item
        width 90%

    .funders
      .items-list
        flex-flow column wrap
        margin 5em 0
        .item
          width 100%
          margin 1em 0
          .title
            min-height 1em
      .expert-wapper
        padding-bottom 10px
        .expert-item
          width 46%
          p.brief
            text-indent 0

    .footprint
      li
        width 49%
        p
          line-height 1.2
          margin-top 0.3em
    .linked
      .friends
        li
          width 32%
          margin-right 2%
          margin-bottom 1%
          &:nth-child(3n+0)
            margin-right 0%
    .about
      .help
        .img
          width 100%
        .desc
          margin 10px 0 0 0
          width 100%
          font-size 24px
          line-height 1.2
          font-weight 300
  .vfooter
    .footer-wrap
      overflow hidden
</style>



// WEBPACK FOOTER //
// En.vue?40d2af36